<template>
  <div class="signAction" ref="signAction" :style="styles">
    <sketch></sketch>
  </div>
</template>

<script>
import Sketch from '../components/Sketch';
import Util from '../util/Util';
import Signal from '../signal/Signal';
import { mapActions, mapState } from 'vuex';
import TiwTranscode from '../util/TiwTranscode';
import _getParams from "lml-tools/lib/_get-params"
export default {
  name: 'Main',
  mixins: [Signal],
  components: {
    Sketch,
  },

  data() {
    return {
      styles: {}
    };
  },

  computed: {
    ...mapState(['classInfo']),
  },
  created(){
    let params = _getParams()
    let userId = params.rToken || params.userId || '123'
    let roomId = +params.room_id
    if(!roomId) return this.$toasted.error("参数不正确");;
    let classInfo = { userId, classId: roomId }
    TiwTranscode.getWhiteBoardInfo(userId,(data)=>{
      classInfo.sdkAppId = +data.sdkAppId;
      classInfo.userSig = data.userSig;
      console.log(classInfo);
      this.$store.commit('classInfo', classInfo);
      this.joinClassroom();
    })
    
  },
  mounted() {
    this.setSize()
    // this.joinClassroom();
  },

  methods: {
    ...mapActions(['setSignalReady']),
    setSize(){
        const scale = 234/141;
        let maxh = this.$refs.signAction.offsetHeight
        let maxw = this.$refs.signAction.offsetWidth
        let iw = maxh * scale;
        if(iw<=maxw) {
            this.styles = {
                width: iw+'px',
                height: maxh+'px'
            };
        }else{
            let ih = maxw / scale;
            this.styles = {
                width: maxw+'px',
                height: ih+'px'
            };
        };
    },
    async joinClassroom() {
      // 1. 准备好信令通道
      let error;
      // 2. 登录
      [error] = await Util.awaitWrap(this.joinSignal());
      if (error) {
        this.$toasted.error(error.message);
        console.error(
          error.code,
          error.message,
          'TIM的错误码文档: https://cloud.tencent.com/document/product/269/1671',
        );
        this.$store.commit('setSignalReady', false);
        this.setSignalReady(false);
        this.$router.push('/login');
      } else {
        // 3. 加入课堂
        [error] = await Util.awaitWrap(this.createAndJoinSignal());
        if (error) {
          this.$toasted.error(error.message);
          console.error(
            error.code,
            error.message,
            'TIM的错误码文档: https://cloud.tencent.com/document/product/269/1671',
          );
          this.$store.commit('setSignalReady', false);
          this.setSignalReady(false);

        } else {

          this.setSignalReady(true);
          this.sendBoardRealtimeDataMessage('abled',"TXSignalReady") //发送签名准备状态 - lml-自定义
        }
      }
    },

    async quitClassroom(cb = null) {
      // 1. 准备好信令通道
      const [error] = await Util.awaitWrap(this.quitSignal());
      if (error) {
        this.$toasted.error(error.message);
        console.error(
          error.code,
          error.message,
          'TIM的错误码文档: https://cloud.tencent.com/document/product/269/1671',
        );
      }
      cb && cb();
    },
  },
};
</script>

<style lang="less" scoped>
.bdall { position: relative; }
.bdall:after { content: ''; position: absolute; width: 200%; height: 200%; border: 1px solid #ccc; left: 0; top: 0; -webkit-transform-origin: 0 0; transform-origin: 0 0; -webkit-transform: scale(0.5, 0.5); transform: scale(0.5, 0.5); -webkit-box-sizing: border-box; box-sizing: border-box; }

.signAction{
  position: absolute;
    top: 14px;
    left: 14px;
    bottom: 14px;
    right: 14px;
    margin: auto;
    border: 1px solid #ccc;
}
</style>
